import { planningAPI } from "../../axios";

export const actions = {

    //PlanningApi
    GetPlanningApis(context, data){
        return planningAPI.get(`PlanningApi/TargetTemplateDeliveryUnit/${data}`);
    },
    GetPlanningApisByOPCR(context, data){
        return planningAPI.get(`PlanningApi/PreOPCR/${data}`);
    },
    GetAllPlanningApis(context, data){
        return planningAPI.get(`PlanningApi/All/PreOPCR/${data}`);
    },
    GetPlanningApisByTarget(context, data){
        return planningAPI.get(`PlanningApi/PlanningTarget/${data}`);
    },
    GetPlanningApisByTargetAndOPCR(context, data){
        return planningAPI.get(`PlanningApi/PlanningTarget/Opcr/${data.preplanningTargetId}/${data.preOPCRId}`);
    },
    GetPlanningApisByDU(context, data){
        return planningAPI.get(`PlanningApi/DeliveryUnit/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetPlanningBudgets(context, data){
        return planningAPI.get(`PlanningApi/BudgetItems/${data}`);
    },
    GetSinglePlanningApi(context, data){
        return planningAPI.get(`PlanningApi/${data}`);
    },
    UpdatePlanningApi(context, data){
        return planningAPI.put(`PlanningApi/${data.id}`, data);
    },
    DeletePlanningApi(context, data){
        return planningAPI.delete(`PlanningApi/${data}`);
    },
    CreatePlanningApi(context, data){
        return planningAPI.post(`PlanningApi`, data);
    },
    PlanningApiDates(context, data){
        return planningAPI.put(`PlanningApi/Dates/${data.id}`, data);
    },
    PostPlanning(context, data){
        return planningAPI.post(`PlanningApi/Post/${data}`);
    },
    PendingPlanning(context, data){
        return planningAPI.get(`PlanningApi/Pending/${data.campusId}/${data.cycle}`);
    },
    FinancePendingPlanning(context, data){
        return planningAPI.get(`PlanningApi/Pending/Finance/${data.campusId}/${data.cycle}`);
    },
    ApprovedPlanning(context, data){
        return planningAPI.get(`PlanningApi/Approved/${data.campusId}/${data.cycle}`);
    },
    ApprovePlanning(context, data){
        return planningAPI.post(`PlanningApi/Approve/${data}`);
    },
    ReturnApi(context, data){
        return planningAPI.post(`PlanningApi/Return/${data.id}`);
    },
    FinanceApprovedPlanning(context, data){
        return planningAPI.get(`PlanningApi/Approved/Finance/${data.campusId}/${data.cycle}`);
    },
    FinanceApprovePlanning(context, data){
        return planningAPI.post(`PlanningApi/Approve/Finance/${data}`);
    },
    FinanceReturnApi(context, data){
        return planningAPI.post(`PlanningApi/Return/Finance/${data.id}`);
    }
}